import { Button, Grid, Typography } from "@mui/material"
import moment from "moment"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import failureBanner from "../../../../assets/payment_failure_banner.svg"
import { DeviceType } from "../../../../services/ntuc/memberService/oaMembership"
import { OrderRequest, postCreateOrder, ServiceType } from "../../../../services/ntuc/memberService/payment"
import { getRecurringPayment } from "../../../../services/ntuc/paymentService/payment"
import { MembershipPaymentRoute } from "../../../../views/membership-payment-flow/MembershipPaymentFlow/MembershipPaymentFlow"
import { RecurringPaymentAcknowledgementPageProps } from "../../../../views/recurring-payment-flow/AcknowledgementPage/AcknowledgementPage"
import PaymentAcknowledgementBanner from "../../PaymentAcknowledgementBanner"

const RecurringPaymentFailurePage = (props: RecurringPaymentAcknowledgementPageProps) => {
    const { orderId, membershipId, onNavigateTo } = props
    const { t } = useTranslation(`acknowledgement`)
    const [loading, setLoading] = useState(false)

    const order: OrderRequest = {
        endDate: moment().toISOString(),
        startDate: moment().toISOString(),
        serviceType: ServiceType.CHANGE_MODE,
        noOfMonths: 0,
        amount: 0 + ``,
        isOneTimePayment: false,
        isRecurringPayment: true,
        membershipId: parseInt(membershipId),
        deviceType: DeviceType.WEB,
    }

    const handleHomeClick = () => {
        if (window.myNtucConfig.paymentBackToHomeHomeUrl != undefined) {
            window.location.replace(window.myNtucConfig.paymentBackToHomeHomeUrl)
        } else {
            onNavigateTo(MembershipPaymentRoute.Main)
        }
    }

    const redirectToPaymentGateway = (clientOrderId: string) => {
        window.location.replace(getRecurringPayment(clientOrderId))
    }

    const handleTryAgainClick = () => {
        setLoading(true)
        postCreateOrder(order)
            .then(response => response.data.content.clientOrderId)
            .then(redirectToPaymentGateway)
            .catch(error => error.response.data.content)
            .then(console.error)
            .then(() => setLoading(false))
    }

    return (
        <Grid rowSpacing={3} container justifyContent="center" padding={2}>
            <PaymentAcknowledgementBanner bannerUrl={failureBanner} alt="Payment failure banner" />
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center" variant="h2">{t(`recurring.failure.title`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center">{t(`recurring.failure.body`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography color="text.secondary" textAlign="center">{t(`success.reference`)}</Typography>
                <Typography textAlign="center" data-testid="reference">{orderId}</Typography>
            </Grid>
            <Grid container item xs={12} sm={12} md={6} lg={6} mt={3} justifyContent='center'>
                <Button onClick={handleTryAgainClick} variant="contained" color="primary" size="large" sx={{ marginX: 5, marginY: 1 }} disabled={loading}>
                    {t(`buttons.try_again`)}
                </Button>
                <Button onClick={handleHomeClick} variant="contained" color="secondary" size="large" sx={{ marginX: 5, marginY: 1 }}>
                    {t(`buttons.home`)}
                </Button>
            </Grid>
        </Grid>
    )
}

export default RecurringPaymentFailurePage